export default __webpack_public_path__ + "static/media/Certificate.520a68b5.png";